module.exports = __webpack_public_path__ + "static/media/train_52.111ba50d.jpg";